export function splitTime(minutes: number): { d: number; h: number; m: number; s: number } {
  const d = Math.floor(minutes / (24 * 60));
  const remainingMinutes = minutes % (24 * 60);
  const h = Math.floor(remainingMinutes / 60);
  const m = Math.floor(remainingMinutes) % 60;
  const s = Math.round((minutes % 1) * 60); // we need to nice handle: (123 / 60) * 60 = 122.99999999999999
  return { d, h, m, s };
}

export function formatDurationLong(minutes: number): string {
  const { d, h, m, s } = splitTime(minutes);

  return `${d}d ${h.toString().padStart(2, '0')}h ${m.toString().padStart(2, '0')}m ${s.toString().padStart(2, '0')}s`;
}

export function toMonthPeriod(date: Date) {
  return date
    .toDateString()
    .replace(/....(....).../, '$1')
    .toUpperCase();
}

export function formatDurationShort(minutes: number): string {
  const { d, h, m, s } = splitTime(minutes);

  if (minutes < 1) {
    return `${s}s`;
  }

  if (minutes < 60) {
    return `${m}m${s > 0 ? ` ${s}s` : ''}`;
  }

  if (minutes < 24 * 60) {
    return `${h}h${m > 0 ? ` ${m}m` : ''}`;
  }

  return `${d}d${h > 0 ? ` ${h}h` : ''}`;
}
